import { render, staticRenderFns } from "./HomeFeaturesSend.vue?vue&type=template&id=29ee4a9a&scoped=true"
import script from "./HomeFeaturesSend.vue?vue&type=script&lang=js"
export * from "./HomeFeaturesSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ee4a9a",
  null
  
)

export default component.exports